module.exports = __webpack_public_path__ + "img/webp_2.c10fc01c.gif";